var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"card-container"},[_c('v-card-title',{staticClass:"headline"},[_vm._v("Pengajuan Terkirim")]),_c('v-card-subtitle',{staticClass:"subtitle-1"},[_vm._v(" Terima kasih telah mengirin pengajuan anda. ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }